import { render, staticRenderFns } from "./SidecartRelatedItem.vue?vue&type=template&id=4d931c9c&lang=pug&"
import script from "./SidecartRelatedItem.vue?vue&type=script&lang=js&"
export * from "./SidecartRelatedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d931c9c')) {
      api.createRecord('4d931c9c', component.options)
    } else {
      api.reload('4d931c9c', component.options)
    }
    module.hot.accept("./SidecartRelatedItem.vue?vue&type=template&id=4d931c9c&lang=pug&", function () {
      api.rerender('4d931c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/sidecart/SidecartRelatedItem.vue"
export default component.exports